import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"

export const BlendMode = z.union([z.literal("over"), z.literal("add"), z.literal("multiply"), z.literal("darken"), z.literal("lighten"), z.literal("screen")])
export type BlendMode = z.infer<typeof BlendMode>

export const Definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            backgroundImage: anyImageOpResult,
            foregroundImage: anyImageOpResult,
            alpha: z.optional(z.union([anyImageOpResult, z.number()])), // for alpha blending, if supplied this will be used instead of alpha channel of foregroundImage
            premultipliedAlpha: z._default(z.boolean(), true),
            blendMode: BlendMode,
        }),
    },
}
